import { render, staticRenderFns } from "./HomeScreenUx.vue?vue&type=template&id=5ad973a8&scoped=true"
import script from "./HomeScreenUx.vue?vue&type=script&lang=js"
export * from "./HomeScreenUx.vue?vue&type=script&lang=js"
import style0 from "./HomeScreenUx.vue?vue&type=style&index=0&id=5ad973a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad973a8",
  null
  
)

export default component.exports